export default __webpack_public_path__ + "static/media/eb-wht-banner-3.376876b9.jpg";